import Logo from '../../logo.png';
import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

function NotificationHeader({ emails }) {

    const navigate = useNavigate();
    var targetHomeUrl = "/AppRequester";
    const storedRole = localStorage.getItem('role');

    const firstName = localStorage.getItem('firstName');

    switch (storedRole) {
        case 'Visit Requester':
        case 'Requester':
            targetHomeUrl = '/AppRequester';
            break;
        case 'Admin':
            targetHomeUrl = '/AppAdmin';
            break;
        case 'Family':
            targetHomeUrl = '/AppFamily';
            break;
        case 'MLTUser':
            targetHomeUrl = '/AppMltEvent';
            break;
        case 'FamilyCoordinator':
            targetHomeUrl = '/AppFamily';
            break;
        case 'MLTCoordinator':
            targetHomeUrl = '/AppMltEvent';
            break;
        default:
            targetHomeUrl = '/';  // Redirect to home or login in case of an invalid role
            break;
    }

    // bell notification logic 
    const [countOfNotification, setCountOfNotification] = useState();

    useEffect(() => {
        if (emails) {
            setCountOfNotification(emails);
        }
    }, [emails]);

    return (
        <>
            <nav className="navbar navbar-expand-lg bg-body-tertiary" >
                <div className="container-fluid">
                    <div className="d-flex align-items-center">
                        <a className="navbar-brand mb-0" href="">
                            <img src={Logo} alt="Logo" onClick={() => navigate(targetHomeUrl)} width="100" className="d-inline-block align-text-top" />
                        </a>
                    </div>
                    <form className="d-flex align-items-center">
                        <span className="badge" style={{ fontSize: '10px', color: "darkblue", fontWeight: '500' }}>
                            {/* Yellow User Icon */}
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_4740_321)">
                                    <rect width="24" height="24" rx="12" fill="#0000A0"></rect>
                                    <rect x="7" y="4" width="10" height="10" rx="5" fill="#FFC107"></rect>
                                    <rect x="-6" y="16" width="36" height="36" rx="18" fill="#FFC107"></rect>
                                </g>
                                <defs>
                                    <clipPath id="clip0_4740_321">
                                        <rect width="24" height="24" rx="12" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span className='p-2'>{firstName}</span>
                        </span>
                        <span className="badge " style={{ fontSize: '12px', color: 'darkblue' }}>
                            <b className='p-2'>{countOfNotification}</b>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.5 13.7246C19.125 11.8496 18.9 9.89961 18.675 8.02461C18.225 4.04961 16.05 2.09961 12.075 2.09961C8.1 2.09961 5.925 4.04961 5.475 8.02461C5.25 9.97461 4.95 11.8496 4.65 13.7246L3.75 18.7496H8.775C8.775 20.6246 10.275 22.0496 12.075 22.0496C13.875 22.0496 15.375 20.5496 15.375 18.7496H20.4L19.5 13.7246ZM7.125 8.17461C7.5 5.09961 8.925 3.74961 12.075 3.74961C15.15 3.74961 16.65 5.09961 17.025 8.17461C17.25 10.0496 17.475 11.9246 17.85 13.7246H6.3C6.675 11.9246 6.9 10.0496 7.125 8.17461ZM12.075 20.3996C11.175 20.3996 10.425 19.6496 10.425 18.7496H13.725C13.725 19.6496 12.975 20.3996 12.075 20.3996ZM5.7 17.0996L6 15.4496H18.075L18.375 17.0996H5.7Z" fill="#0000A0" />
                            </svg>
                        </span>
                    </form>
                </div>
            </nav>
        </>
    );
}

export default NotificationHeader;